import styled from 'styled-components';
import { getColor, getColorShade, getSizeBy } from '../../../../src/styled/utils';
import { Subtitle1, Subtitle2 } from '../../typography';
export const BarChartContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
export const StyledBarchartLineContainer = styled.div `
  position: relative;
  display: flex;
  width: 100%;
  height: ${({ thickness }) => (thickness ? `${thickness}px` : getSizeBy(0.5))};
`;
export const BarchartBackground = styled.div `
  width: 100%;
  height: ${({ thickness }) => (thickness ? `${thickness}px` : getSizeBy(0.5))};
  background-color: ${({ backgroundColor }) => backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : getColorShade('onSurface', 'border')};
  border-radius: ${getSizeBy(0.5)};
`;
export const BarchartLine = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: ${({ thickness }) => (thickness ? `${thickness}px` : getSizeBy(0.5))};
  background-color: ${({ color }) => color || getColor('primary')};
  border-radius: ${getSizeBy(0.5)};
  transition: width 0.3s ease-out 0.1s;
`;
export const PercentageValue = styled(Subtitle1) `
  display: flex;
  align-items: center;
  padding-left: ${getSizeBy(1)};
`;
export const LabelWrapper = styled.div `
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: ${getSizeBy(1)};
`;
export const BarChartWrapper = styled.div `
  padding-top: ${getSizeBy(2.5)};
`;
export const PrimaryTextWrap = styled(Subtitle1) `
  color: ${getColorShade('onSurface', 'highEmphasis')};
`;
export const SecondaryTextWrap = styled(Subtitle2) `
  color: ${getColorShade('onSurface', 'highEmphasis')};
`;
